export default __webpack_public_path__ + "static/media/2020-AMcover.d3da1d70.png";